import React, { useEffect, useState } from "react";
import "../../assets/css/statusBar/StatusBar.css";

/**
 * Creates a StatusBar with a green/white background and black text
 * @param status - number shown on status bar (integer required)
 * @param suffix - default is "%", can use '%', 'pts' or other string
 * @returns a custom StatusBar component
*/
const StatusBar = ({status, suffix = "%"}) => {
    const [fixedStatus, setFixedStatus] = useState(0);

    useEffect(() => {
        if (typeof(status) !== 'number') {
            console.log(typeof(status));
        } else {
           setFixedStatus(Math.min(Math.max(status, 0), 100));
        }
    }, [fixedStatus])
        
    return (
        <div className="statusBar-container">
            <div 
                className="statusBar-fill"
                style={{ width: `${fixedStatus}%`}}
            />
            <div className="statusBar-text">{fixedStatus}{suffix}</div>
        </div>
    )
};

export default StatusBar;